import { inject, Injectable } from '@angular/core';
import { Route } from '@angular/router';
import { ROUTE_IDS, StepDefinition } from '@lx/quote-tool/shared/types';
import { ConfirmationComponent } from './confirmation.component';

const stepId = ROUTE_IDS.CONFIRMATION;

@Injectable({
  providedIn: 'root',
})
export class ConfirmationResolver {
  private stepDefinition: StepDefinition = {
    stepId,
    previousStep: () => ROUTE_IDS.BOOKING_FORM,
  };

  resolve(): StepDefinition {
    return this.stepDefinition;
  }
}

export const stepRoute: Route = {
  path: stepId,
  resolve: {
    stepDefinition: () => inject(ConfirmationResolver).resolve(),
  },
  component: ConfirmationComponent,
};
